import { render, staticRenderFns } from "./AttachRequiredDocuments.vue?vue&type=template&id=21985c26"
import script from "./AttachRequiredDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachRequiredDocuments.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports